import React, { PureComponent } from 'react';
import { isEmpty, isEqual } from 'lodash';
import $ from 'jquery';
import * as environmentService from '../../../utils/general/environmentService';
import * as HTML_RENDITION from '../../../utils/general/general';
import { switchPage } from '../../../utils/api/pageControl';
import { RenditionLoadable } from '../../../utils/general/LoadableRelated';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import { connect } from 'react-redux';
import { IBookMeetingEntitlement, IReducerState } from '../../../states/renditionStates';
import { cv_setTeamDirLink } from '../../../cvMobile/cvAuthor';
import { checkDomEntitlement } from '../../../utils/general/checkDomEntitlement';
import personIconbig from '../../../../style/img/Person-Icon-big.png';
import ReactTooltip from "react-tooltip";
import { enterKeyPressed } from '../../../utils/general/enterKey';
import AuthorsDirectory from "../../../components/author/authorsDirectory";
import AuthorPhone from "../../../components/author/authorPhone";
import AuthorEmail from "../../../components/author/authorEmail";
import AuthorName from "../../../components/author/authorName";

interface IAuthorOldBrandingProps {
    initialData: any;
    mainSource: any;
    source: any;
    editor: any;
    showPartialAuthors?: boolean;
    defaultAuthorsToShow?: number;
    serial: number;
    // reportsToRevisit: any;
    teamDirectoryUrl: string | undefined;
    bookMeetingUrl: string | undefined;
    analystInfoData?: any;
    currentAuthorID: string;
    bookMeetingEntitlement: IBookMeetingEntitlement;
    showOldBranding: boolean;
}

let image: string;

const FormPopup = RenditionLoadable({
    loader: () => import('../../../modalrelated/formPopup'),
}, "formPopup", Date.now());

export class AuthorOldBranding extends PureComponent<IAuthorOldBrandingProps, any> {
    private REQUEST_CONTACT = React.createRef<HTMLDivElement>();
    private BOOK_MEETING = React.createRef<HTMLDivElement>();
    private ANALYST_NAME = React.createRef<HTMLDivElement>();

    constructor(props: IAuthorOldBrandingProps) {
        super(props);
        this.state = {
            modalStatus: false
        };
    }

    public componentDidMount() {
        this.checkCurrentCompoentDOMEntit();
    }

    public checkCurrentCompoentDOMEntit() {
        this.REQUEST_CONTACT.current && checkDomEntitlement(this.REQUEST_CONTACT.current);
        this.ANALYST_NAME.current && checkDomEntitlement(this.ANALYST_NAME.current);
    }

    public openModal(e: any) {
        // track author email click
        if (e.target.parentElement?.className?.indexOf("deaden") > -1){
            return;
        }
        const { source } = this.props;
        // Important!!! the close modal action can through bubbling propagation to here, So that we can set the status again!
        // Improtant!!! you must setState in below if else to avoid cause reRender!
        if (e.target.id === "modalClose" || e.target.getAttribute('data-btn') === 'close') { // Improtant!!! if you want close modal in more case only change this if
            this.setState({
                modalStatus: false,
            });
            $('.triggered_popup_flag').focus().removeClass('triggered_popup_flag');
        } else if (this.state.modalStatus === false) { // Improtant!!! don't change this if in any case
            this.setState({
                modalStatus: true,
            });
            e.target.className += " triggered_popup_flag";
            RSCH_HTML_TRACKING_CONFIG.trackAuthorPhoneIconClick(source.analystId, source.title);
        }
    }

    public renderAuthor() {
        const { initialData, source, mainSource, editor, serial } = this.props;

        const isPrimaryAuthor = () => {
            return source.coverageType == undefined
                || source.coverageType?.toUpperCase() == 'PRI'
                || source.authorType == 'primary';
        };

        const isACAnalyst = () => {
            return (source.authorRow
                && HTML_RENDITION.parseToBoolean(source.authorRow.isACAnalyst));
        };
        const showAuthorIconPhone = () => {
            return mainSource.issuerPage
                && mainSource.issuerPage.financialsBlock
                && HTML_RENDITION.parseToBoolean(mainSource.issuerPage.financialsBlock.callFlag);
        };

        const openReportsToRevist = (filterValue: string, selectedAuthorTabIndex?: number, isRR?: boolean) => {
            if (initialData.isDeaden('ANALYST_NAME')) {
                return;
            }
            RSCH_HTML_TRACKING_CONFIG.trackReportsToRevistClick(source.analystId, source.authorWithAC);

            if (!HTML_RENDITION.parseToBoolean(initialData.analyst_page_switch_entrance)) {
                window.HTML_RENDITION.scope.bioIframePageUrl = null;
                window.HTML_RENDITION.scope.analystId = source.analystId;
                window.HTML_RENDITION.scope.researchPageUrl = null;
                window.HTML_RENDITION.scope.selectedAuthorTabIndex = selectedAuthorTabIndex ? selectedAuthorTabIndex : 0;
                switchPage('authorsPage', 'authorName', filterValue);
                return;
            }
            if (isRR) {
                openRedesignAnalystPageWithRRDefault();
            } else {
                openRedesignAnalystPage();
            }
        };
        const openRedesignAnalystPage = () => {
            const analystNumber = source.analystNumber || mainSource.analystInfo[source.analystId].analystNumber;
            HTML_RENDITION.openAnalystPage(analystNumber);
        };
        const analystID = this.props.currentAuthorID.toLowerCase();
        let selectedAnalystIndex = 0;
        // if (analystID && this.props.reportsToRevisit) {
        //     for (let i = 0; i < this.props.reportsToRevisit[analystID]?.length; i++){
        //         if (this.props.reportsToRevisit[analystID][i]?.author == analystID) {
        //             selectedAnalystIndex = i;
        //             break;
        //         }
        //     }
        // }
        const openRedesignAnalystPageWithRRDefault = () => {
            // let r2rLink = this.props.reportsToRevisit[analystID][selectedAnalystIndex].r2rLink;
            // if (HTML_RENDITION.isCVMobileApp()) {
            //     r2rLink = HTML_RENDITION.getRelativePath(r2rLink);
            // }
            // HTML_RENDITION.openPageFromRendition(r2rLink);
        };
        const showReportsToRevisit = () => {
            // return this.props.reportsToRevisit
            //     && this.props.reportsToRevisit[analystID]
            //     && this.props.reportsToRevisit[analystID][selectedAnalystIndex]
            //     && this.props.reportsToRevisit[analystID][selectedAnalystIndex].r2rLink
            //     && !source.isEditor;
        };
        const showClickableValidatedAuthorName = () => {
            return mainSource.analystInfo
                && mainSource.analystInfo[this.props.currentAuthorID]
                && mainSource.analystInfo[this.props.currentAuthorID].analystNumber
                && mainSource.analystInfo[this.props.currentAuthorID].analystStatus == 'OK';
        };

        if (source.photo) image = environmentService.getImagePath(source.photo);
        const defaultImg = personIconbig;

        if (!image) {
            image = defaultImg;
        }
        if (source.analystId) {
            source.authorWithAC = source.displayName + (isACAnalyst() ? " (AC)" : "");
        }

        let bookMeetingUrl = '';
        if ( !isEmpty(this.props.bookMeetingUrl)) {
            bookMeetingUrl = this.props.bookMeetingUrl + source.analystId;
            if (HTML_RENDITION.isCVMobileApp()) {
                bookMeetingUrl = cv_setTeamDirLink(bookMeetingUrl);
            }
        }

        const authorRequstContactPhoneCallDiv = () => {
            if (!showAuthorIconPhone() || !isEmpty(bookMeetingUrl)) {
                return null;
            }
            return (
                   <div ref={this.REQUEST_CONTACT}
                        data-tip={initialData.request_contact_entitlement_message}
                        data-entitlement="REQUEST_CONTACT" id={'authorIconPhone' + serial} className="authorIconPhone" title={source.authorWithAC} data-name={source.analystId}>
                        <span onClick={(e) => this.openModal(e)} className="phone-icon icon-sprite">
                            {this.state.modalStatus &&
                                <FormPopup titleSource={mainSource.i18n.requestContact} typeIdentifier={'Request Contact'} closeable={true}/>
                            }
                        </span>
                    </div>
            );
        };

        const openAnalystBookMeeting = (e: any) => {
            RSCH_HTML_TRACKING_CONFIG.trackBookMeetingClick();
            return true;
        };

        const openAnalystBookMeetingReadonly = (e: any) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
        };

        const authorBookMeetingDiv = () => {
            // only show book meeting for user  with HTML_PORTLET_REQUEST_CALL_EXTERNAL
            // and show for internal user
            if (isEmpty(bookMeetingUrl)) {
                return null;
            }

            if (initialData.isPublic) {
                return null;
            }
            const ajaxBookMeetingCheck : boolean = initialData.mode != 'preview_mode' && initialData.enableOpenDocBookMeetingCheck == false;
            const newBookMeetingEntitled : boolean =  ajaxBookMeetingCheck ? this.props.bookMeetingEntitlement.newBookMeetingEntitled : (!isEmpty(initialData.newBookMeetingEntitled) && isEqual(initialData.newBookMeetingEntitled, 'true'));
            const newBookMeetingReadonly : boolean =  ajaxBookMeetingCheck ? this.props.bookMeetingEntitlement.newBookMeetingReadonly : (!isEmpty(initialData.newBookMeetingReadonly) && isEqual(initialData.newBookMeetingReadonly, 'true'));
            const clickableAnalyst = showClickableValidatedAuthorName();

            if (!newBookMeetingEntitled && clickableAnalyst && newBookMeetingReadonly) {
                return (
                    <div ref={this.BOOK_MEETING}
                        id={'authorIconBookMeeting' + serial} className="authorIconBookMeeting" title={'Schedule a Call or Meeting with ' + source.authorWithAC} data-name={source.analystId}>
                        <a tabIndex={0} href={bookMeetingUrl} className="x-rsch-hyperlink author-book-meeting-link"
                        aria-label={'Schedule a Call or Meeting with ' + source.authorWithAC} role="link"
                        onClick={(e) => openAnalystBookMeetingReadonly(e)}
                        >
                            <div className="author-book-meeting-icon" role="img" aria-label="author book meeting icon"></div>
                            <div className="author-book-meeting-title">{mainSource.i18n.bookMeeting}</div>
                        </a>
                    </div>
                );
            }

            if (!newBookMeetingEntitled) {
                return null;
            }

            if (!clickableAnalyst) {
                return null;
            }

            return (
                <div ref={this.BOOK_MEETING}
                     id={'authorIconBookMeeting' + serial} className="authorIconBookMeeting" title={'Schedule a Call or Meeting with ' + source.authorWithAC} data-name={source.analystId}>
                     <a tabIndex={0} href={bookMeetingUrl} className="x-rsch-hyperlink author-book-meeting-link"
                        aria-label={'Schedule a Call or Meeting with ' + source.authorWithAC}
                        onClick={(e) => openAnalystBookMeeting(e)} target="_blank" role="link"
                        onKeyPress={(e) => enterKeyPressed(e, openAnalystBookMeeting.bind(this, e))}
                        >
                         <div className="author-book-meeting-icon" role="img" aria-label="author book meeting icon"></div>
                         <div className="author-book-meeting-title">{mainSource.i18n.bookMeeting}</div>
                     </a>
                 </div>
            );

        };

        return (
            <div>
                {source.cftcValue && <div className="cftcTitle"><div className="cftcTitleInner">{source.cftcValue}</div></div>}
                {source.analystId &&
                    <div id={'author' + serial} className={"author" + (isPrimaryAuthor() ? ' primary-author' : '')}>
                        {authorRequstContactPhoneCallDiv()}
                        <AuthorName
                            serial={serial}
                            authorWithAC={source.authorWithAC}
                            analystId={source.analystId}
                            clickableAnalyst={showClickableValidatedAuthorName()}
                            isACAnalyst={isACAnalyst()}
                            displayName={source.displayName}
                            analystNumber= {source.analystNumber || mainSource.analystInfo?.[source?.analystId]?.analystNumber || ''}
                        />

                        {authorBookMeetingDiv()}
                        {source.headingValue && source.headingValue !== 'null' && <div className="authorTeamHeadings text-overflow">{source.headingValue}</div>}
                        {source.isEditor && <div className="authorName text-overflow authorEditor">{editor}</div>}
                        <AuthorEmail
                            isNewOutput={initialData.isNewOutput}
                            displayEmail={source.displayEmail}
                            emailAnalystFlag={mainSource.issuerPage?.financialsBlock?.emailAnalystFlag}
                            analystId={source.analystId}
                            serial={serial}
                            product={mainSource.metadata.product}
                            issuer={mainSource.metadata.issuer}
                            researchArea={mainSource.metadata.researchArea}
                            productBranding={mainSource.metadata.productBranding}
                            titleText={mainSource.metadata.titleText}
                            email={source.email}
                        />

                        <AuthorPhone
                            serial={serial}
                            phone={source.phone}
                            isDeaden={initialData.isDeaden('ANALYST_PHONE')}
                            analystId={source.analystId}
                            analystFlag={mainSource.issuerPage.financialsBlock?.callAnalystFlag}
                            displayPhone={initialData.isNewOutput ? HTML_RENDITION.parseToBoolean(source.displayPhone) : (isPrimaryAuthor() || source.authorRow?.displayPhone)}
                        />

                        {/* {showReportsToRevisit() &&
                            <div ref={this.ANALYST_NAME} data-entitlement="ANALYST_NAME" id={'authorLongShelfLife' + serial}
                                className="authorLongShelfLife text-overflow" title={source.authorWithAC} data-name={source.analystId}>
                                <a tabIndex={0} className={initialData.isDeaden('ANALYST_NAME') ? 'deaden' : 'x-rsch-hyperlink'}
                                   aria-label={mainSource.i18n.reportsToRevisit} role="link"
                                   onKeyPress={(e) => enterKeyPressed(e, openReportsToRevist.bind(this, source.displayName, 2, true))}
                                   onClick={() => openReportsToRevist(source.displayName, 2, true)}>
                                    {mainSource.i18n.reportsToRevisit}
                                </a>
                            </div>
                        } */}
                        <AuthorsDirectory
                            showOldBranding={this.props.showOldBranding}
                            new_team_directory_url={initialData.new_team_directory_url}
                            teamDirectoryFlag={mainSource.issuerPage.financialsBlock.teamDirectoryFlag}
                            author_directory={initialData.author_directory}
                        />
                    </div>
                }
            </div>
        );
    }

    public render() {
        return (
            <div className="hide author_card" data-serial={this.props.serial}>
                {this.renderAuthor()}
                {this.props.initialData.isDeaden('REQUEST_CONTACT') &&
                    (<ReactTooltip
                        place={"bottom"}
                        textColor={"#333"}
                        backgroundColor={"#ddd"}
                        arrowColor={"transparent"}
                    />)
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        currentAuthorID: state.commonStateReducer.currentAuthorID,
    };
};

export default connect(mapStateToProps)(AuthorOldBranding);